import { useState } from "react";
import { FaHashtag, FaUserCircle } from "react-icons/fa";
import Search from "../UI/Search";
import ThemeIcon from "../UI/ThemeIcon";
import Modal from "../UI/Modal";
import i18n from "../../i18n";
import LangIcon from "./LangIcon";

const TopNavigation = ({ pagename }) => {
  const [isOpen, setisOpen] = useState(false);
  const [lang, setlang] = useState("en");
  const langChangeHandler = () => {
    if (lang === "en") {
      setlang("fr");
      i18n.changeLanguage(lang);
    } else setlang("en");
    i18n.changeLanguage(lang);
  };

  return (
    <div className="top-navigation">
      <FaHashtag size="20" className="title-hashtag" />
      <h5 className="title-text">{pagename}</h5>
      <Search />
      <LangIcon onClick={langChangeHandler} lang={lang} />
      <ThemeIcon />
      <FaUserCircle size="24" className="top-navigation-icon" onClick={() => setisOpen(true)} />
      <Modal open={isOpen} onClose={() => setisOpen(false)} />
    </div>
  );
};

export default TopNavigation;
